import {Tr} from "@/i18n/i18n";
import Scene = Phaser.Scene;
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {Keys} from "@/constants/key";
import {SquareButton} from "@/scenes.ui/square-button";
import SpriteUtils from "@/utils/sprite-utils";
import Sprite = Phaser.GameObjects.Sprite;
import {Lang} from "@/store/player/types";
import {BasePanel} from "@/scenes.ui/base-panel";

export class PartIntroPanel extends BasePanel {

    protected onAcceptCallback: (() => unknown) | undefined;

    constructor(scene: Scene, canvas: HTMLCanvasElement, lang: Lang, partNumber: number,
                onAcceptCallback: () => unknown) {
        super(scene, canvas, canvas.width / 2, canvas.height / 2 - 30, undefined);

        let background = SpriteUtils.addSprite(this.scene, 0, 0, Keys.ATLAS_UI, Keys.UI_BLACK).setInteractive();
        SpriteUtils.setDispSize(background, canvas!.width * 2, canvas!.height * 2);
        this.add(background);
        this.preInit(scene, canvas);

        let window = SpriteUtils.addImage(this.scene, 0, 0, Keys.UI_WINDOW_MIDDLE_BIG).setOrigin(0.5, 0.5);
        this.add(window);

        let titleEl = TextUtils.addTextByFamily(this.scene, this.getTitleText(partNumber), 0, -262, '#ffffff', 16,
            'normal', 420, Fonts.ARIAL_MT)
            .setOrigin(0.5, 0.5);

        this.add([window, titleEl]);

        this.onAcceptCallback = onAcceptCallback;

        let nameText = TextUtils.addTextByFamily(scene, this.getTopText(partNumber), 0, -180,
            '#ffd465', 18, 'bold', 450, Fonts.MYRIADPRO_REGULAR);


        let light = SpriteUtils.addSprite(this.scene, 0, -90, Keys.ATLAS_PROFILE, Keys.UI_ART_LIGHT);
        let icon = SpriteUtils.addSprite(this.scene, -0, -100, PartIntroPanel.getKey(lang, partNumber));


        this.add([nameText, light, icon]);
        this.afterIconInit(scene, icon);

        let blockSecond = TextUtils.addTextByFamily(scene, this.getBottomText(partNumber),
            0, icon.y + 110, '#FFD465', 15, 'normal', 450, Fonts.ARIAL_MT);
        this.add(blockSecond);

        this.addCustomButton(0, 150,Tr('otlichno').toUpperCase(), Keys.UI_ART_GREEN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, onAcceptCallback);
    }

    private getTitleText(partNumber: number) {
        return Tr('cont');
    }

    private getTopText(partNumber: number) {
        if (partNumber === 7) {
            return Tr('and.nw');
        }
        return Tr('wlcm');
    }

    private getBottomText(partNumber: number) {
        if (partNumber === 7) {
            return Tr('wn');
        }
        return Tr('t.a');
    }

    protected preInit(scene: Scene, canvas: HTMLCanvasElement) {
        let background = this.scene.add.sprite(0, 0, Keys.ATLAS_UI, Keys.UI_BLACK).setInteractive();
        SpriteUtils.setDispSize(background, canvas!.width * 2, canvas!.height * 2);
        this.add(background);
    }

    protected afterIconInit(scene: Scene, icon: Sprite) {

    }

    protected addCustomButton(x: number, y: number, text: string, buttonBackground: string,
                              buttonAtlas: string | undefined, buttonIcon: string,
                              callback?: () => unknown) {
        let okButton = new SquareButton(this.scene, x, y, 0, buttonBackground,
            buttonAtlas, buttonIcon, text.toLocaleUpperCase(), false);

        okButton.setCallback(() => {
            if (callback != null) {
                callback();
            }
        });

        this.add(okButton);
    }

    private static getKey(lang: Lang, partNumber: number) {
        switch (lang) {
            case Lang.RU:
            case Lang.ANY:
                return partNumber === 6 ? Keys.P6_RU : Keys.P7_RU;
            case Lang.EN:
                return partNumber === 7 ? Keys.P6_EN : Keys.P7_EN;
        }
        return '';
    }
}
